import React, { useState, useEffect } from 'react';

function FPSCounter({ isEnabled }) {
  const [fps, setFps] = useState(0);

  useEffect(() => {
    if (!isEnabled) return;

    let lastTime = performance.now();
    let frameCount = 0;
    let fpsValue = 0;

    const updateFPS = () => {
      const currentTime = performance.now();
      frameCount++;
      const deltaTime = (currentTime - lastTime) / 1000; // Convert to seconds

      if (deltaTime >= 1) {
        fpsValue = Math.round(frameCount / deltaTime);
        setFps(fpsValue);
        frameCount = 0;
        lastTime = currentTime;
      }

      if (isEnabled) {
        requestAnimationFrame(updateFPS);
      }
    };

    const animationFrameId = requestAnimationFrame(updateFPS);

    return () => cancelAnimationFrame(animationFrameId);
  }, [isEnabled]);

  if (!isEnabled) return null;

  // Determine color based on FPS
  const getFpsColor = () => {
    if (fps >= 55) return 'bg-green-500'; // Green for ~60 FPS
    if (fps >= 30) return 'bg-orange-500'; // Orange for 30-54 FPS
    return 'bg-red-500'; // Red for <30 FPS
  };

  return (
    <div
      className={`fixed top-2 left-2 px-2 py-1 rounded-md ${getFpsColor()} bg-opacity-75 text-white text-xs font-mono z-50 shadow-md select-none`}
      role="status"
      aria-label={`Current FPS: ${fps}`}
    >
      {fps} FPS
    </div>
  );
}

export default FPSCounter;